import React from "react";
import { Check, CircleCheck } from "lucide-react";
import "bootstrap/dist/css/bootstrap.min.css";
import { makeStyles } from "@material-ui/core";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";

// Styling
import "./Assets/styles/pricingpage-styles.css";

// Images
import img_logo from "./Assets/images/logo.png";

const PricingPage = () => {
  const classes = useStyles();

  return (
    <div className="pricingpage">
      <header className="header">
        <div className="container">
          <div className={classes.navbar_start}>
            <div className="logo">
              <Link to="/">
                <img src={img_logo} alt="" />
              </Link>
            </div>
            <Link to="/pricing" className={classes.navLink}>
              Pricing
            </Link>
          </div>
          <Link className="btn_design" to="/login">
            Login
          </Link>
        </div>
      </header>
      <div className="container py-5">
        <div className="text-center mb-5">
          <h1 className="fs-1 mb-4 mt-5">Pricing that grows with your impact</h1>
          <p className="text-muted">Start with a risk-free tryout. Upgrade when you're ready to scale</p>
        </div>
        <div className="row g-4 justify-content-center">
          {/* Pricing Tier 1 */}
          <div className="col-md-4">
            <div className="card">
              <div className="card-body d-flex flex-column text-start">
                <h5 className="card-title">Tryout</h5>
                <p className="card-subtitle text-muted mt-2">A risk-free way to grow your business!</p>
                <h2 className="my-3 fs-4">€625/month</h2>
                {/* divider */}
                <div className="divider mb-3" />
                <p className="mb-2">What's included</p>
                <ul className="list-unstyled">
                  <li className="mb-2 d-flex align-items-center gap-2">
                    <CircleCheck className="feature-check" />1 Project
                  </li>
                  <li className="mb-2 d-flex align-items-center gap-2">
                    <CircleCheck className="feature-check" />1 Company
                  </li>
                  <li className="mb-3 d-flex align-items-center gap-2">
                    <CircleCheck className="feature-check" />3 Month access
                  </li>
                </ul>
                <div className="divider mb-3" />
                <ul className="list-unstyled mb-4">
                  <li className="mb-2 d-flex align-items-center gap-2">
                    <CircleCheck className="feature-check" />
                    Training available
                  </li>
                  <li className="mb-2 d-flex align-items-center gap-2">
                    <CircleCheck className="feature-check" />
                    Not good? Money back!
                  </li>
                </ul>
                <Link className="btn_design_secondary mt-auto" to="/bookdemo">
                  Tell me more
                </Link>
              </div>
            </div>
          </div>

          {/* Pricing Tier 2 */}
          <div className="col-md-4">
            <div className="card">
              <div className="card-body d-flex flex-column text-start">
                <h5 className="card-title">Professional</h5>
                <p className="card-subtitle text-muted mt-2">Less work, more insights!</p>
                <h2 className="my-3 fs-4">€1455/month</h2>
                <div className="divider mb-3" />
                <p className="mb-2">What's included</p>
                <ul className="list-unstyled">
                  <li className="mb-2 d-flex align-items-center gap-2">
                    <CircleCheck className="feature-check" />3 Simultaneous projects
                  </li>
                  <li className="mb-2 d-flex align-items-center gap-2">
                    <CircleCheck className="feature-check" />1 Company
                  </li>
                  <li className="mb-3 d-flex align-items-center gap-2">
                    <CircleCheck className="feature-check" />
                    Limited simulations
                  </li>
                </ul>
                <div className="divider mb-3" />
                <ul className="list-unstyled mb-4">
                  <li className="mb-2 d-flex align-items-center gap-2">
                    <CircleCheck className="feature-check" />
                    Training available
                  </li>
                </ul>
                <Link className="btn_design_secondary mt-auto" to="/bookdemo">
                  Tell me more
                </Link>
              </div>
            </div>
          </div>

          {/* Pricing Tier 3 */}
          <div className="col-md-4">
            <div className="card">
              <div className="card-body d-flex flex-column text-start">
                <h5 className="card-title">Enterprise</h5>
                <p className="card-subtitle text-muted mt-2">All the features</p>
                <h2 className="my-3 fs-4">Custom pricing</h2>
                <div className="divider mb-3" />
                <p className="mb-2">What's included</p>
                <ul className="list-unstyled">
                  <li className="mb-2 d-flex align-items-center gap-2">
                    <CircleCheck className="feature-check" />
                    Unlimited projects
                  </li>
                  <li className="mb-2 d-flex align-items-center gap-2">
                    <CircleCheck className="feature-check" />
                    Unlimited companies
                  </li>
                  <li className="mb-3 d-flex align-items-center gap-2">
                    <CircleCheck className="feature-check" />
                    Advanced simulations
                  </li>
                </ul>
                <div className="divider mb-3" />
                <ul className="list-unstyled mb-4">
                  <li className="mb-2 d-flex align-items-center gap-2">
                    <CircleCheck className="feature-check" />
                    Full onboarding available
                  </li>
                  <li className="mb-2 d-flex align-items-center gap-2">
                    <CircleCheck className="feature-check" />
                    Strategic support available
                  </li>
                </ul>
                <Link className="btn_design_secondary mt-auto" to="/bookdemo">
                  Tell me more
                </Link>
              </div>
            </div>
          </div>
        </div>
        <div className="cta-block text-center max-w-600">
          <h2 className="fs-3">Still in doubt?</h2>
          <p className="text-muted mt-3">Try Taplr for 3 months. See the difference in your P&L. Doesn't work? Then you get your money back. No risk involved.</p>
          <Link className="btn_design mt-4" to="/bookdemo">
            Tell me more
          </Link>
        </div>
      </div>
      <footer className="footer">
        <div className="container">
          <p>
            © 2025 <Link to="/"> Taplr </Link>. All rights reserved. Taplr is a product by Flagstone BV, Stedestraat 51, 8530 Harelbeke - Belgium. <Link to="/privacypolicy">Privacy Policy</Link>
          </p>
        </div>
      </footer>
    </div>
  );
};

const useStyles = makeStyles((theme) => ({
  header: {
    backgroundColor: "#231F20",
    paddingTop: "65px",

    [theme.breakpoints.down("lg")]: {
      paddingTop: "20px",
    },
  },

  container: {
    maxWidth: "1560px",

    margin: "0 auto",
    padding: "0 15px",
    boxSizing: "border-box",
  },

  navbar_start: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "48px",
    padding: "0 15px",
    boxSizing: "border-box",
    height: "100%",
    [theme.breakpoints.down("lg")]: {
      padding: "0 10px",
    },
    [theme.breakpoints.down("md")]: {
      padding: "0 5px",
    },
  },

  navLink: {
    color: "#fff",
    fontSize: "18px",
    fontWeight: "500",
    textDecoration: "none",
    padding: "0 15px",
    boxSizing: "border-box",
    "&:hover": {
      color: "#fff",
      textDecoration: "underline",
    },
  },

  row: {
    display: "flex",
    flexWrap: "wrap",
    [theme.breakpoints.down("md")]: {
      marginBottom: "30px",
    },
  },

  col5: {
    flex: "0 0 41.666%",
    maxWidth: "41.666%",
    [theme.breakpoints.down("md")]: {
      flex: "0 0 100%",
      maxWidth: "100%",
    },
  },

  col6: {
    flex: "0 0 50%",
    maxWidth: "50%",
    [theme.breakpoints.down("md")]: {
      flex: "0 0 100%",
      maxWidth: "100%",
    },
  },

  col7: {
    flex: "0 0 58.333%",
    maxWidth: "58.333%",
    [theme.breakpoints.down("md")]: {
      flex: "0 0 100%",
      maxWidth: "100%",
    },
  },

  logo: {
    // image inside
    "& img": {
      [theme.breakpoints.down("md")]: {
        width: "130px",
      },

      [theme.breakpoints.down("sm")]: {
        width: "118px",
      },
    },
  },

  banner: {
    padding: "30px 0 110px",
    backgroundColor: "#231F20",
    boxSizing: "border-box",

    [theme.breakpoints.down("lg")]: {
      padding: "30px 0 70px",
    },

    [theme.breakpoints.down("md")]: {
      padding: "0px 0 70px",
      marginTop: "-1px",
    },
  },
}));

export default PricingPage;
